import React, { FC } from 'react'
import { IonModal, IonHeader } from '@ionic/react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import './index.scss'

interface ITypeInfo {
  label: string;
  value: string;
  icon: string;
}

interface IProps {
  typeArr: ITypeInfo[];
  reject?: () => void;
  resolve?: (type: string) => void;
}
const MoreActionsType: FC<IProps> = (props) => {
  const { reject, resolve, typeArr } = props
  return (
    <IonModal
      cssClass='more-actions-modal'
      isOpen
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span className='title'>{i18n.t('mkt.coupon.moreActions')}</span>
        <div className='right' onClick={reject}>
          <i className='iconfont icon-close'></i>
        </div>
      </IonHeader>
      <div className='modal-content'>
        {
          typeArr.map((item: any, index: number) => {
            return (
              <div key={index} className='type-item' onClick={() => resolve && resolve(item.value)}>
                <div className='type-area'>
                  <div className='left'>
                    <i className={`iconfont ${item.icon}`}></i>
                  </div>
                  <span>{item.label}</span>
                </div>
              </div>
            )
          })
        }
      </div>
    </IonModal>
  )
}

export default observer(MoreActionsType)
